import script from "./FakeHeaderBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./FakeHeaderBar.vue?vue&type=script&lang=ts&setup=true"

import "./FakeHeaderBar.vue?vue&type=style&index=0&id=07c34ed7&lang=stylus&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07c34ed7"]])

export default __exports__